import { type RouteRecordRaw } from 'vue-router'

import { eModules } from '@/constants'
import Layout from '@/layout/index.vue'

export const publicApiDashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/public-api-dashboard',
    components: {
      default: () => import('../views/dashboard.vue'),
      navbar: () => import('../views/navbar/index.vue'),
    },
    name: 'Public Api Dashboard',
    meta: {
      title: 'Public Api Dashboard', // TODO i18n
      icon: 'regions',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.PUBLIC_API_DASHBOARD],
    },
  },
  {
    path: '/public-api-dashboard/:id',
    components: {
      default: () => import('../views/board.vue'),
      navbar: () => import('../views/navbar/index.vue'),
    },
    name: 'public-api-board',
    meta: {
      title: 'Board', // TODO i18n
      icon: 'regions',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.PUBLIC_API_DASHBOARD],
    },
  },
  {
    path: '/public-api-dashboard/:id/print',
    components: {
      default: () => import('../views/board-print.vue'),
      // navbar: () => import('../views/navbar/index.vue')
    },
    name: 'public-api-board-print',
    meta: {
      title: 'Public Api Board print', // TODO i18n
      icon: 'regions',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.PUBLIC_API_DASHBOARD],
    },
  },
]
